module.exports = __webpack_public_path__ + "img/wd.png";